module.exports = __webpack_public_path__ + "img/thumbnail_PlainsZebra_j_normal.c8e6e3e3.png";